import React from 'react';
import { useFormularioSecretariaMunicipalAgriculturaStore } from '../../../../../../stores/forms/formularioAgricultura.store';

// Pure helper: phone mask
export const mascaraTelefone = (valor: string) => {
  const valorLimpo = valor.replace(/\D/g, '');
  return valorLimpo.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
};

// Pure helper: email regex and validator
export const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const isValidEmail = (email: string) => regexEmail.test(email);

// Pure helper: create initial servidores array
export const makeInitialServidores = (quantidade: number) => {
  const servidores: any[] = [];
  for (let i = 0; i < quantidade; i++) {
    servidores.push({
      nome: '',
      tipo_vinculo: '',
      telefone: '',
      grau_escolaridade: '',
      email: '',
      medio_tecnico_concluido: '',
      superior_concluido: '',
    });
  }
  return servidores;
};

// Pure helper: validate servidores preenchidos
export const areServidoresPreenchidos = (servidores: any[] = []) => {
  return servidores.every(servidor => {
    const grauEscolaridadeValue = Array.isArray(servidor.grau_escolaridade)
      ? (servidor.grau_escolaridade[0] || '')
      : (servidor.grau_escolaridade || '');

    return (
      (servidor.nome || '').length > 0 &&
      (servidor.tipo_vinculo || '').length > 0 &&
      (servidor.telefone || '').length >= 15 &&
      (grauEscolaridadeValue || '').length > 0 &&
      regexEmail.test(servidor.email || '') &&
      (grauEscolaridadeValue !== 'Médio técnico' || (servidor.medio_tecnico_concluido || '').length > 0) &&
      ((grauEscolaridadeValue !== 'Superior' && grauEscolaridadeValue !== 'Pós-graduado') || (servidor.superior_concluido || '').length > 0)
    );
  });
};

// Calculate concursados automatically based on tipo_vínculo
export const calculateConcursadosAutomaticamente = (servidores: any[] = []) => {
  return servidores.filter(servidor =>
    servidor.tipo_vinculo === 'Efetivo' || servidor.tipo_vinculo === 'Efetivo com cargo comissionado'
  ).length;
};

export const canAdvance = (total: number, servidores: any[] = []) => {
  const quantidadeValida = (total ?? 0) > 0;
  const servidoresPreenchidos = areServidoresPreenchidos(servidores);
  return quantidadeValida && servidoresPreenchidos;
};

export const useStep6 = () => {
  const { formulario, setPartialForm, salvarRascunho } = useFormularioSecretariaMunicipalAgriculturaStore();

  const stepAtual = formulario?.step_atual ?? 1;
  const totalSteps = 8;

  const updateServidor = (index: number, campo: string, valor: any) => {
    const servidores = formulario?.quadro_servidores_secretaria_lista ?? [];
    const novoServidor = { ...servidores[index], [campo]: valor };
    const novosServidores = [...servidores];
    novosServidores[index] = novoServidor;
    setPartialForm('quadro_servidores_secretaria_lista', novosServidores);
  };

  const initializeServidores = (quantidade: number) => {
    const servidores = makeInitialServidores(quantidade);
    setPartialForm('quadro_servidores_secretaria_lista', servidores);
  };

  React.useEffect(() => {
    const quantidade = formulario?.quadro_servidores_secretaria_quantidade ?? 0;
    if (quantidade > 0 && (!formulario?.quadro_servidores_secretaria_lista || formulario.quadro_servidores_secretaria_lista.length !== quantidade)) {
      initializeServidores(quantidade);
    }
  }, [formulario?.quadro_servidores_secretaria_quantidade]);

  const quantidadeValida = (formulario?.quadro_servidores_secretaria_quantidade ?? 0) > 0;

  const servidoresPreenchidos = areServidoresPreenchidos(formulario?.quadro_servidores_secretaria_lista ?? []);

  const podeAvancar = quantidadeValida && servidoresPreenchidos;

  const handleAvancar = async () => {
    if (!podeAvancar) return;
    setPartialForm('step_atual', stepAtual + 1);
    await salvarRascunho();
  };

  const handleVoltar = async () => {
    setPartialForm('step_atual', Math.max(1, stepAtual - 1));
    await salvarRascunho();
  };

  return {
    formulario,
    mascaraTelefone,
    updateServidor,
    initializeServidores,
    podeAvancar,
    handleAvancar,
    handleVoltar,
    setPartialForm,
    quantidadeValida,
    calculateConcursadosAutomaticamente,
    regexEmail,
    stepAtual,
    totalSteps,
  };
};
